export default __webpack_public_path__ + "static/media/laboratory.d2fc5269.svg";